"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _UiContext = _interopRequireDefault(require("../context/UiContext"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function useIsCurrentLocation() {
  const [ui] = (0, _react.useContext)(_UiContext.default);
  const {
    _location: {
      pathname: _pathname
    } = {}
  } = ui;
  const location = (0, _reactRouterDom.useLocation)();
  const {
    pathname
  } = location;
  const isCurrentLocation = pathname === _pathname;
  return isCurrentLocation;
}
var _default = exports.default = useIsCurrentLocation;